<template>
  <div>
    <intro />

    <section id="promotion">
      <b-container class="px-md-5">
        <b-alert v-b-toggle.collapse-promotion show variant="warning" class="mb-0 po">
          <div class="d-flex flex-row align-items-center">
            <i class="fas fa-circle-info mr-2" aria-hidden="true"/>
            <h3>
              {{ $t('hos.promotion.title') }}
            </h3>
            <i class="fas fa-chevron-down ml-2" aria-hidden="true"/>
          </div>
        </b-alert>

        <b-collapse id="collapse-promotion">
          <b-card v-html="$t('hos.promotion.content')" />
        </b-collapse>
      </b-container>
    </section>

    <what />

    <limit />

    <news />

    <how />

    <why />

    <who />

    <sfs />

    <outro />
  </div>
</template>

<script>
import Intro from './home/Intro.vue';
import What from './home/What.vue';
import Limit from './home/Limit.vue';
import News from '../../commons/components/hos/News.vue';
import How from '../../commons/components/hos/How.vue';
import Why from '../../commons/components/hos/Why.vue';
import Who from '../../commons/components/hos/Who.vue';
import Outro from '../../commons/components/hos/Outro.vue';
import Sfs from '../../commons/components/sfs/Main.vue';

export default {
  components: {
    Intro,
    What,
    Limit,
    News,
    How,
    Why,
    Who,
    Outro,
    Sfs,
  },
};
</script>

<style lang="scss">
#app {
  background: #fff
    url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="600px" height="600px" viewBox="0 0 100 100"><path d="M5.5 12a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM6 46a2 2 0 10.001-3.999A2 2 0 006 46zM31.5 8a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-3 30a2 2 0 10.001-3.999A2 2 0 0028.5 38zm16-10a2.5 2.5 0 000-5 2.5 2.5 0 000 5zM40 17.5a1 1 0 100-2 1 1 0 000 2zm-10 31a1 1 0 100-2 1 1 0 000 2zm-12.5-25a1 1 0 100-2 1 1 0 000 2zM77.53 24.742a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-21.5-3.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm31.5 15.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-22.5 11.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm28-38a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-25 3.5a2 2 0 100-4 2 2 0 000 4zm23 35.5a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-37-16a1 1 0 100-2 1 1 0 000 2zM29.5 74a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM8 70.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM39.5 86a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM17 97.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm28-38a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20 63a2 2 0 10.001-3.999A2 2 0 0020 63zm23 35.5a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-37-16a1 1 0 100-2 1 1 0 000 2zM77.53 74.242a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-12.5 23.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm14.5-40a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-3 30a2 2 0 100-4 2 2 0 000 4zm14.5 11a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm1.5-21a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-4.5-10.5a1 1 0 100-2 1 1 0 000 2zm-34 15.5a1 1 0 100-2 1 1 0 000 2z" fill="%23e2e8f0" fill-opacity=".3"/></svg>');
  position: relative;
}

/* SFS */
#support {
  background:
    url('../../public/img/gattino-galileo.png') no-repeat 10% calc(100% + 40px),
    linear-gradient(to bottom, var(--f-g1), transparent);

  .col-lg-7 .ombre {
    margin-top: 3rem;
    margin-bottom: 1rem;
  }
}

#f-sfs + div { /* #outro parent */
   background:
    transparent
    url('../../public/img/gattino-galileo.png')
    no-repeat
    10% calc(100% + 20px);
}

/* Framanav */
#home #fp-alert {
  background: var(--f-d1);
}

.f-bs4 #f-footer {
  border: none !important;
}

#promotion {
  margin: 2rem 0 0 0;

  @media (min-width: 768px) {
    margin: 2rem 2rem 0 2rem;
  }

  /* Container */
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;

    /* Alert & Collapse */
    > div {
      width: 100%;
      max-width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      @media (min-width: 768px) {
        max-width: 80%;
      }

      @media (min-width: 1024px) {
        max-width: 60%;
      }
    }

    .alert {
      cursor: pointer;
    }

    #collapse-promotion > div {
      border: 1px solid var(--f-o2);
      border-top: none;
      padding: 1rem;
    }

    h3 {
      color: var(--f-o10);
      font-size: 1.25rem;
      font-weight: 400;
      margin: 0;
    }
  }
}
</style>
